import * as React from "react";

import AppLayout from "Layout";
import {REPRICING_ROUTES} from "@constants"
import RepricingHomePage from "./Home";
import RepricingCrudPage from "./Crud";


export const RepricingRoutes = {
    path: REPRICING_ROUTES.PATH,
    title: REPRICING_ROUTES.TITLE,
    accessKey: REPRICING_ROUTES.ACCESS_KEY,
    icon: 'money-check-dollar-pen',
    description: "Apply automatic repricing according to your business rules and the results of the competition",
    element: <AppLayout />,
    children: [{
        element: <RepricingHomePage />,  index: true,
        dashboardKey: REPRICING_ROUTES.ACCESS_KEY
    }, {
        path: REPRICING_ROUTES.FORM_PATH,
        dashboardKey: REPRICING_ROUTES.FORM_ID,
        element: <RepricingCrudPage />
    }]
}